import { useEffect, useRef } from 'react'
import { initTracking, trackPageView, trackScrollDepth, trackTimeOnPage } from '../tracking'

type Depth = 25 | 50 | 75 | 100
const DEPTHS: Depth[] = [25, 50, 75, 100]
const TIMES: Array<30 | 60 | 120> = [30, 60, 120]

/** Initializes tracking once and fires scroll-depth + time-on-page milestones. */
export function usePageTracking(): void {
  const firedDepths = useRef<Set<Depth>>(new Set())

  useEffect(() => {
    initTracking()
    trackPageView()

    const timers = TIMES.map((seconds) =>
      window.setTimeout(() => trackTimeOnPage(seconds), seconds * 1000),
    )

    const onScroll = () => {
      const doc = document.documentElement
      const scrollable = doc.scrollHeight - window.innerHeight
      if (scrollable <= 0) return
      const percent = (window.scrollY / scrollable) * 100
      DEPTHS.forEach((depth) => {
        if (percent >= depth && !firedDepths.current.has(depth)) {
          firedDepths.current.add(depth)
          trackScrollDepth(depth)
        }
      })
    }

    window.addEventListener('scroll', onScroll, { passive: true })
    return () => {
      window.removeEventListener('scroll', onScroll)
      timers.forEach(window.clearTimeout)
    }
  }, [])
}
